import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import {
  isServerUnavailableError,
  notifyServerUnavailable,
  SERVER_UPGRADATION_MODAL_EVENT,
} from "../../utils/http/http-common";
import "./index.css";

const ServerUpgradtionModal = (props) => {
  const { show, setShow } = props;
  const [isGlobalVisible, setIsGlobalVisible] = useState(false);

  const isControlled = typeof show === "boolean";
  const isVisible = isControlled ? show : isGlobalVisible;

  const closeModal = useCallback(() => {
    if (isControlled) {
      setShow?.(false);
      return;
    }

    setIsGlobalVisible(false);
  }, [isControlled, setShow]);

  useEffect(() => {
    if (isControlled) return;

    const showModal = () => {
      setIsGlobalVisible(true);
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (isServerUnavailableError(error)) {
          notifyServerUnavailable();
        }

        return Promise.reject(error);
      }
    );

    window.addEventListener(SERVER_UPGRADATION_MODAL_EVENT, showModal);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      axios.interceptors.response.eject(interceptorId);
      window.removeEventListener(SERVER_UPGRADATION_MODAL_EVENT, showModal);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeModal, isControlled]);

  const handleClick = () => {
    closeModal();
  };

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      closeModal();
    }
  };

  if (!isVisible) return null;

  return (
    <div
      className="server-upgradation-modal-backdrop"
      role="presentation"
      onClick={handleBackdropClick}
    >
      <div
        className="server-upgradation-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="server-upgradation-modal-title"
        aria-describedby="server-upgradation-modal-description"
      >
        <button
          type="button"
          className="server-upgradation-modal-close"
          aria-label="Close update popup"
          onClick={closeModal}
        >
          ×
        </button>

        <div className="server-upgradation-modal-icon" aria-hidden="true">
          <span>i</span>
        </div>

        <h2 id="server-upgradation-modal-title">
          We&apos;re Updating Project Inclusion
        </h2>

        <p id="server-upgradation-modal-description">
          We are working to improve your experience. Services are expected to
          resume within 48 hours.
        </p>

        <p className="server-upgradation-modal-thanks">
          Thank you for your patience and understanding!.
        </p>

        <button
          type="button"
          className="server-upgradation-modal-ok"
          onClick={handleClick}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default ServerUpgradtionModal;
